module.exports = __webpack_public_path__ + "static/img/9.be96771.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka2/9.jpg
// module id = WPQ1
// module chunks = 16